import { CommonModule } from "@angular/common";
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GroupDeleteConfirmationComponent } from "@app/directives/_misc/delete-confirm/group-delete-confirm/group-delete-confirm.component";
import { CoreDirectivesModule } from "@directives/_core/_core.directives.module";
import { DelayedHoverDirective } from "@directives/_misc/delayedHover.directive";
import { DeleteConfirmationComponent } from "@directives/_misc/delete-confirm/delete-confirm.component";
import { DepotNameComponent } from "@directives/_misc/depotName/depotName.component";
import { MultiStepIndicatorComponent } from "@directives/_misc/multiStepIndicator/multiStepIndicator.component";
import { TooltipDirective } from "@directives/_misc/tooltip/tooltip.directive";
import { TrailerComponent } from "@directives/_misc/trailer/trailer.component";
import { VProgressBar } from "@directives/_misc/v-progress-bar/v-progress-bar.component";
import { PipesModule } from "src/app/_pipes/_pipes.module";
import { AccountSwitcherComponent } from "./accountSwitcher/accountSwitcher.component";
import { AsyncObservableComponent } from "./async-observable/async-observable.component";
import { BatteryIndicatorComponent } from "./batteryIndicator/batteryIndicator.component";
import { BreadcrumbsComponent } from "./breadcrumbs/breadcrumbs.component";
import { CountToDirective } from "./countTo.directive";
import { DayOfWeekPickerComponent } from "./day-of-week-picker/day-of-week-picker.component";
import { DriverNameComponent } from "./driver-name/driver-name.component";
import { DriverImageComponent } from "./driverImage/driverImage.component";
import { VFlvPlayer } from "./flvPlayer/flv-player.component";
import { FullScreenButtonComponent } from "./fullScreenButton/fullScreenButton.component";
import { HideInProductionDirective } from "./hide-in-production/hide-in-production.directive";
import { HighlightTextDirective } from "./highlight-text/highlight-text.component";
import { IfEnabledDirective } from "./if-enabled.directive";
import { LoadingIndicatorComponent } from "./loadingIndicator/loadingIndicator.component";
import { LocationInformationComponent } from "./location-information/location-information.component";
import { NavCountComponent } from "./navCount/navCount.component";
import { RecentlySelectedComponent } from "./recently-selected/recently-selected.component";
import { SiteStatusIndicatorComponent } from "./site-status-indicator/site-status-indicator.component";
import { TachoModeComponent, TachoModeStatusComponent } from "./tachoMode/tachoMode.directive";
import { TemperatureReadingComponent } from "./temperatureReading/temperatureReading.component";
import { TrendArrowComponent } from "./trendArrow/trendArrow.component";
import { UnitConversionSuffixComponent } from "./unitConversionSuffix.component";
import { VectorDotsComponent } from "./vector-dots/vector-dots.component";
import { VehicleOnlineStatusComponent } from "./vehicle-online-status-indicator/vehicle-online-status.component";
import { VeriMarkerComponent } from "./veriMarker/veriMarker.directive";
import { VerticalCollapsableDivider } from "./vertical-collapsable-divider/vertical-collapsable-divider.component";
import { VideoDownloadStatusComponent } from "./video-download-status/video-download-status.component";

const privateComponents: any[] = [

];

const publicComponents: any[] = [
    LoadingIndicatorComponent,
    TachoModeComponent,
    TachoModeStatusComponent,
    BreadcrumbsComponent,
    VehicleOnlineStatusComponent,
    VideoDownloadStatusComponent,
    DriverImageComponent,
    TrendArrowComponent,
    LocationInformationComponent,
    TemperatureReadingComponent,
    BatteryIndicatorComponent,
    UnitConversionSuffixComponent,
    VeriMarkerComponent,
    NavCountComponent,
    DepotNameComponent,
    MultiStepIndicatorComponent,
    FullScreenButtonComponent,
    AccountSwitcherComponent,
    DayOfWeekPickerComponent,
    VerticalCollapsableDivider,
    SiteStatusIndicatorComponent,
    DriverNameComponent,
    DeleteConfirmationComponent,
    GroupDeleteConfirmationComponent,
    VProgressBar,
    TrailerComponent,
    VFlvPlayer,
    AsyncObservableComponent,
    RecentlySelectedComponent,
    VectorDotsComponent
];

const declarations: any[] = [
    CountToDirective,
    DelayedHoverDirective,
    TooltipDirective,
    IfEnabledDirective,
    HighlightTextDirective,
    HideInProductionDirective
];

@NgModule({
    imports: [
        ReactiveFormsModule,
        CommonModule,
        //FormsDirectivesModule,
        BrowserAnimationsModule,
        PipesModule,
        HttpClientModule,
        CoreDirectivesModule
    ],
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...declarations],
    exports: [...publicComponents, ...declarations]
})
export class MiscDirectivesModule {
    constructor() {
    }
}
